import { SellItem } from "../../data/types";

/**
 * 상품 이미지 alt 텍스트 생성 (SEO 최적화)
 */
export function generateProductImageAlt(
  item: Partial<SellItem>,
  imageIndex: number = 0
): string {
  const productName = (item as any)?.title || 
    `${(item as any)?.brand || ""} ${(item as any)?.model || ""}`.trim() || 
    "악기";
  const category = (item as any)?.category || "악기";
  const price = item.price ? item.price.toLocaleString() : "";
  const region = item.region || "";
  
  if (imageIndex === 0) {
    const parts = [productName, "메인 이미지"];
    if (category) parts.push(category);
    if (price) parts.push(`${price}원`);
    if (region) parts.push(region);
    return parts.join(" - ");
  }
  
  return `${productName} 상세 이미지 ${imageIndex + 1} - ${category} 카테고리`;
}

/**
 * 카테고리 이미지 alt 텍스트 생성
 */
export function generateCategoryImageAlt(categoryName: string): string {
  return `${categoryName} 카테고리 이미지 - ToneMarket`;
}

/**
 * 프로필 이미지 alt 텍스트 생성
 */
export function generateProfileImageAlt(nickname: string): string {
  return `${nickname}님의 프로필 사진`;
}

